// combatpro/treasure/treasureResultOps.js
//
// Pure operations on a generated treasure RESULT object (edit / add / remove /
// reroll-one / recompute). Every result item carries a transient `uid` so the UI can
// target a specific line reliably even when ids repeat. Used by both the fast monster
// modal and the full Treasure page. No DOM, no optional chaining, no em dash.

import { generateCategoryItem } from './treasureEngine';

var _uid = 0;
export function nextUid() { _uid++; return 'ti_' + Date.now().toString(36) + '_' + _uid; }

// Ensure every item has a uid (called after generation).
export function withUids(result) {
  if (!result) { return result; }
  var items = (result.items || []).map(function (it) { return it.uid ? it : Object.assign({}, it, { uid: nextUid() }); });
  return Object.assign({}, result, { items: items });
}

export function recompute(result) {
  var total = (result.coins && result.coins.value) ? result.coins.value : 0;
  (result.items || []).forEach(function (it) { total += (it.value || 0); });
  return Object.assign({}, result, { totalValue: Math.round(total) });
}

export function removeItem(result, uid) {
  var items = (result.items || []).filter(function (it) { return it.uid !== uid; });
  return recompute(Object.assign({}, result, { items: items }));
}

export function upsertItem(result, item) {
  var items = (result.items || []).slice();
  var norm = Object.assign({}, item);
  norm.qty = Math.max(1, parseInt(norm.qty, 10) || 1);
  norm.unitValue = Math.max(0, Number(norm.unitValue) || 0);
  norm.value = Math.round(norm.unitValue * norm.qty);
  if (!norm.uid) { norm.uid = nextUid(); }
  var idx = -1;
  for (var i = 0; i < items.length; i++) { if (items[i].uid === norm.uid) { idx = i; break; } }
  if (idx >= 0) { items[idx] = norm; } else { items.push(norm); }
  return recompute(Object.assign({}, result, { items: items }));
}

export function rerollItem(catalogue, request, result, uid) {
  var items = (result.items || []).slice();
  var idx = -1;
  for (var i = 0; i < items.length; i++) { if (items[i].uid === uid) { idx = i; break; } }
  if (idx < 0) { return result; }
  var cat = items[idx].category;
  var repl = generateCategoryItem(catalogue, request, cat, Date.now() + idx);
  if (!repl) { return result; }
  repl.uid = uid;
  items[idx] = repl;
  return recompute(Object.assign({}, result, { items: items }));
}
